export default "__VITE_ASSET__DCD8PTuT__"